export enum PortalStartupErrorType {
  None = 'None',
  BusinessDisabled = 'BusinessDisabled',
  UnknownUser = 'UnknownUser',
  UnknownErrorGettingUserData = 'UnknownErrorGettingUserData',
  AuthorisationError = 'AuthorisationError',
  UnknownError = 'UnknownError'
}
